import { render, staticRenderFns } from "./uploadSource.vue?vue&type=template&id=21ed6ce6&scoped=true&"
import script from "./uploadSource.vue?vue&type=script&lang=js&"
export * from "./uploadSource.vue?vue&type=script&lang=js&"
import style0 from "./uploadSource.vue?vue&type=style&index=0&id=21ed6ce6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ed6ce6",
  null
  
)

export default component.exports